import { EmptyStreamCard } from 'components/Cards'
import { FetchMyStreams } from 'components/Fetch'
import FetchPostDestinations from 'components/Fetch/FetchPostDestinations'
import Loader from 'components/SimpleLoader'
import StreamsLoader from 'components/StreamsLoader'
import { Stream } from 'interfaces'
import { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { Route, Routes } from 'react-router'
import { userStreamsWithFeedIdsSelector } from 'services/content/selectors'
import { userDestinationsSelector } from 'services/destinations/selectors'
import styles from './MyStreamsView.pcss'
import SingleStream from './SingleStream'
import { PostDestination } from 'shared'

const BASE_URL = '/content/my-streams'

export default function MyStreamsView() {
  const intl = useIntl()

  const streams: Stream[] = useSelector(userStreamsWithFeedIdsSelector)
  const destinations: { [key: string]: Readonly<PostDestination> } = useSelector(userDestinationsSelector)

  const [streamsFetched, setStreamsFetched] = useState(streams.length !== 0)
  const [error, setError] = useState<any>(undefined)

  const onFetched = useCallback(() => {
    setStreamsFetched(true)
    setError(undefined)
  }, [])

  const onFailed = useCallback((err: any) => {
    setStreamsFetched(true)
    setError(err)
  }, [])

  const renderLoading = () => {
    return <Loader title="Loading Stream..." />
  }

  const renderEmptyView = () => {
    console.log('[MyStreams] error', error)
    // eslint-disable-next-line no-magic-numbers
    const emptyCards = new Array(100).fill('').map((_, i) => (
      <EmptyStreamCard key={i} className={styles.card} />
    ))

    return (
      <div key="grid">
        <header key="header" className={styles.header}>
          <h2 key="title" className={styles['grid-title']}>Streams</h2>
          <p key="hint" className={styles.hint}>
            {intl.formatMessage({ id: 'search.sections.streams.no-results-hint' })}
          </p>
        </header>
        <div className={styles.grid} key="grid-content">
          {emptyCards}
        </div>
      </div>
    )
  }

  const renderStreams = () => {
    return (
      <StreamsLoader
        streams={streams}
        browseUrlBase={BASE_URL}
        destinations={destinations}
      />
    )
  }

  const renderStreamsRoute = () => {
    if (streams.length === 0) {
      return !streamsFetched ? renderLoading() : renderEmptyView()
    }
    return renderStreams()
  }

  return (
    <div data-test="my-streams">
      <FetchMyStreams key="fetch" onFetched={onFetched} onFailed={onFailed} />
      <Routes key="routes">
        <Route key="stream" path=":stream/*" element={<SingleStream />} />
        <Route key="all-streams" path="/" element={renderStreamsRoute()} />
      </Routes>
      <FetchPostDestinations key="fetch-destinations" />
    </div>
  )
}
